<script>
import cloneDeep from "lodash/cloneDeep";
import moment from "moment";
import PagenationContainer from "@/components/common/PagenationContainer.vue";

export default {
  components: {
    PagenationContainer
  },
  data() {

    return {
      userData: {
        staffId: undefined,
        name: undefined,
        phone: undefined,
        role: undefined,
        gender: undefined
      },
      searchData: {
        operateType: undefined
      },
      dateRange: undefined,
      pageCount: 0,
      activePage: 1,
      tableData: [],
      searchArray: [
        {
          label: "状态：",
          keyName: "recordType",
          type: "radio",
          value: "",
          children: [
            {
              label: "全部",
              keyName: ""
            },
            {
              label: "出售",
              keyName: "PAY"
            },
            {
              label: "退款",
              keyName: "REFUND"
            }
          ]
        }
      ],
      buttonArray: [
        {
          text: "最近一周",
          key: "week"
        },
        {
          text: "最近30天",
          key: "month"
        },
        {
          text: "最近90天",
          key: "ninety"
        }
      ]
    };
  },
  created() {
    this.onOperationClick(null, 'month')
    this.loadData();
  },
  methods: {
    async loadData() {
      let params = {
        page: this.activePage - 1,
        size: 10,
        sort: "createdAt,DESC"
      };
      for (let key in this.searchData) {
        if (this.searchData[key]) {
          params[key] = this.searchData[key];
        }
      }
      if (this.dateRange && this.dateRange[0]) {
        params.start = this.dateRange[0] + ' 00:00:00'
      }
      if (this.dateRange && this.dateRange[1]) {
        params.end = this.dateRange[1] + ' 23:59:59';
      }
      const userId = this.$route.params.accountId;
      params.userId = userId;
      params.stationId = this.$cookie.get("stationId");
      const result = await this.$http.GetGameSalesDetail(params);
      console.log("result", result);
      if (result) {
        let temp = [];
        if (result.records.content) {
          this.pageCount = result.records.totalPages;
          this.tableData = result.records.content.map(o => {
            o.buyAt = moment(o.createdAt).format("YYYY-MM-DD HH:mm");
            o.status = o.recordType === "PURCHASE" ?   "购买" : "退款";
            o.totalPrice = (Math.round(o.price * 100) * o.quantity)/100;
            return o;
          });
        }
      }
    },
    onSearch(data) {
      console.log("onSearch", data);
      this.activePage = 1;
      this.loadData();
    },
    onSearchChange(data) {
      this.searchData = data;
    },
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`);
      this.activePage = val;
      this.loadData();
    },
    onOperationClick(row, key) {
      switch (key) {
        case "month":
          this.dateRange = [
            moment()
              .subtract(30, "days")
              .format("YYYY-MM-DD"),
            moment().format("YYYY-MM-DD")
          ];
          break;
        case "ninety":
          this.dateRange = [
            moment()
              .subtract(90, "days")
              .format("YYYY-MM-DD"),
            moment().format("YYYY-MM-DD")
          ];
          break;
        case "week":
          this.dateRange = [
            moment()
              .subtract(6, "days")
              .format("YYYY-MM-DD"),
            moment().format("YYYY-MM-DD")
          ];
          break;
      }
    }
  }
};
</script>
<template>
  <div class="gameSales">
    <el-card class="box-card withoutBorderBottom" shadow="never">
      <el-row :gutter="24">
        <el-col :span="18">
          <div class="TextGroup">
            <div class="dataSearch">
              <span>训练销售时间筛选：</span>
              <el-date-picker
                v-model="dateRange"
                @keyup.enter.native="onSearch"
                size="medium"
                class="dateRange"
                type="daterange"
                range-separator="至"
                format="yyyy-MM-dd"
                value-format="yyyy-MM-dd"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
              ></el-date-picker>
              <textButtonGroup
                class="dataButton"
                :buttonArray="buttonArray"
                @onOperationClick="onOperationClick"
                @keyup.enter.native="onSearch"
              />
              <el-button type="primary" class="searchButton" @click="onSearch" size="mini">搜索</el-button>
            </div>
          </div>

          <!-- <searchFormNew
            class="searchForm"
            @onChange="onSearchChange"
            :searchItemArray="searchArray"
            @onSearch="onSearch"
          /> -->
        </el-col>
      </el-row>
      <el-table
        :data="tableData"
        class="AgencyRangeTable"
        :header-cell-style="{ 'padding-left': '5px',color: 'rgba(0,0,0,0.65)','font-size': '14px', 'background-color': '#fafafa !important'}"
        :cell-style="{'padding-left': '5px'}"
      >
        <el-table-column prop="buyAt" align="left" label="操作日期" width="150"></el-table-column>
        <el-table-column prop="status" align="left" label="状态" width="80"></el-table-column>
        <el-table-column prop="price" align="left" label="单价(元)" width="80"></el-table-column>
        <el-table-column prop="patientName" align="left" label="患者姓名" min-width="115"></el-table-column>
        <el-table-column prop="quantity" align="left" label="数量" width="80"></el-table-column>
        <el-table-column prop="totalPrice" align="left" label="小计（元）" width="125"/>
        <el-table-column prop="stationName" align="left" label="所属医疗机构" min-width="150"></el-table-column>
        <el-table-column prop="doctorName" align="left" label="主治医生" min-width="120"></el-table-column>
      </el-table>
      <PagenationContainer v-if="pageCount > 1">
        <el-pagination
          background
          @current-change="handleCurrentChange"
          :current-page="activePage"
          :page-count="pageCount"
          layout="prev, pager, next, jumper"
        ></el-pagination>
      </PagenationContainer>
    </el-card>
  </div>
</template>

<style lang="scss">
@import "@/css/color.scss";

.gameSales {
  background-color: #f5f6f7;

  .basicInfo {
    margin: 15px 0;

    .grid-content {
      padding: 15px 0px;
      border-radius: 4px;
    }

    .el-pagination {
      text-align: center;
      margin-top: 10px;
    }

    .text {
      font-size: 14px;
      padding-top: 0px;
    }
    .genderStyle {
      // width: 11px;
      height: 17.5px;
      margin-bottom: -2px;
    }
    .item {
      margin-bottom: 18px;

      .checkBoxLabel {
        color: #303133;

        .el-checkbox__input.is-disabled + span.el-checkbox__label {
          color: #303133;
        }
      }
    }

    .clearfix:before,
    .clearfix:after {
      display: table;
      content: "";
    }

    .clearfix:after {
      clear: both;
    }

    .cardTitleText {
      font-size: 16px;
      font-weight: bold;
    }
  }

  .TextGroup {
    display: flex;
    font-size: 14px;
    font-weight: 400;
    color: #606266;
    padding-left: 15px;
    .dateRange {
      width: 250px;
      .el-range-editor--mini.el-input__inner {
        height: 32px;
      }
      .el-range-editor.is-active,
      .el-range-editor.is-active:hover {
        border-color: #00c1de;
      }
      .el-date-table td.today span {
        color: #00c1de;
      }
    }
    .dataButton {
      margin-left: 10px;
      margin-right: 15px;
      display: inline-block;
    }
    .searchButton {
      border-color: #00c1de;
      background-color: #00c1de;
    }
  }
  .searchLocation {
    display: flex;
    text-align: center;
    .line {
      width: 1px;
      height: 40px;
      background-color: #e4e8eb;
      margin-left: 25px;
      margin-right: 25px;
    }
    .saleNumberTitle {
      font-size: 14px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: rgba(0, 0, 0, 0.45);
      line-height: 22px;
    }
    .saleNumber {
      font-size: 25px;
      font-family: HelveticaNeue;
      color: rgba(0, 0, 0, 0.85);
      line-height: 38px;
    }
  }
  .AgencyRangeTable {
    width: 98%;
    margin: auto;

    .el-table__body tr:hover > td {
      background-color: #e6f7ff !important;
      cursor: pointer;
    }

    .el-table__body tr.current-row > td {
      background-color: #e6f7ff !important;
      cursor: pointer;
    }
  }

  .withoutBorderBottom {
    border-bottom: none;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/salesManagement/gameSales.vue